// extracted by mini-css-extract-plugin
module.exports = {"web-breadCrumbRoot":"web-breadCrumbRoot___3lw_P","web-breadCrumb":"web-breadCrumb___23sna","ant-breadcrumb-link":"ant-breadcrumb-link___290-j"};